<template>
<div class="container">
  <ul class="box">
    <li
    v-for="(item,index) in imgList"
    :key="index"

    ><img :src="item.image" alt="">
      <div class="text">{{item.name}}</div>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  name: "CutImg",
  props:{
    imgList:{
      type:Array
    }
  },
  data(){
    return{
    }
  }
}
</script>

<style scoped>
.container{
  height: 320px;
}
.box{
  padding: 0;
  margin: 0;
  width: 100%;
  height: 320px;
  overflow: hidden;
  transition: all .5s;
}
.box li{
  position: relative;
  display: block;
  float: left;
  width: calc(100%/6);
  height: 320px;
  transition: all .5s;
  list-style-type: none;
}
.box:hover li{
  width: 104px;
}
.box li:hover{
  width: 640px;
}
img{
  height: 320px;
  width: 640px;
}
.text{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 30px;
  color: white;
  background-color: rgba(0,0,0,0.3);
  line-height: 30px;
  text-align: center;
  transition: all .3s;
}
</style>



// WEBPACK FOOTER //
// src/components/CutImg.vue